import { ReactNode } from 'react'

import useTranslation from 'next-translate/useTranslation'

import { SKU_OPTIONS } from '@/utils/data/trials/skus'

import { TrialProvider } from '../TrialProvider'
import { TrialFormStatus } from './TrialFormStatus'

type Props = {
	driftPlaybookId: string
	sku?: string
	switchToEnterpriseSku: boolean
	form1CTAText?: string
	form2CTAText?: string
	legalText: ReactNode
	loadingText?: string
	loadingSecondaryText?: string
}

export function TrialForm({
	driftPlaybookId,
	sku,
	switchToEnterpriseSku,
	form1CTAText,
	form2CTAText,
	legalText,
	loadingText,
	loadingSecondaryText
}: Props) {
	const skuValue = sku ?? SKU_OPTIONS[0].value

	const { t } = useTranslation('trials')

	const isForm1CTATextEmpty = !form1CTAText || form1CTAText === '' || form1CTAText === undefined
	const isForm2CTATextEmpty = !form2CTAText || form2CTAText === '' || form2CTAText === undefined
	const isLoadingTextEmpty = !loadingText || loadingText === '' || loadingText === undefined
	const isLoadingSecondaryTextEmpty =
		!loadingSecondaryText || loadingSecondaryText === '' || loadingSecondaryText === undefined

	return (
		<TrialProvider
			skuValue={skuValue}
			driftPlaybookId={driftPlaybookId}
			loadingSecondaryText={
				isLoadingSecondaryTextEmpty ? t('trialForm.loading.body') : loadingSecondaryText
			}
		>
			<TrialFormStatus
				switchToEnterpriseSku={switchToEnterpriseSku}
				form1CTAText={isForm1CTATextEmpty ? t('trialForm.buttons.form1') : form1CTAText}
				form2CTAText={isForm2CTATextEmpty ? t('trialForm.buttons.form2') : form2CTAText}
				loadingText={isLoadingTextEmpty ? t('trialForm.loading.headline') : loadingText}
				legalText={legalText}
			/>
		</TrialProvider>
	)
}
